module.exports = __webpack_public_path__ + "static/img/img14_btn.4a50bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c36/img14_btn.png
// module id = Y3gt
// module chunks = 0